var $2d805fd52bb48883$exports = {};
$2d805fd52bb48883$exports = {
  "alpha": "\u0623\u0644\u0641\u0627",
  "black": "\u0623\u0633\u0648\u062F",
  "blue": "\u0623\u0632\u0631\u0642",
  "blue purple": "\u0623\u0631\u062C\u0648\u0627\u0646\u064A \u0645\u0632\u0631\u0642",
  "brightness": "\u0627\u0644\u0633\u0637\u0648\u0639",
  "brown": "\u0628\u0646\u064A",
  "brown yellow": "\u0623\u0635\u0641\u0631 \u0628\u0646\u064A",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u0633\u0645\u0627\u0648\u064A",
  "cyan blue": "\u0623\u0632\u0631\u0642 \u0633\u0645\u0627\u0648\u064A",
  "dark": "\u062F\u0627\u0643\u0646",
  "gray": "\u0631\u0645\u0627\u062F\u064A",
  "grayish": "\u0645\u0627\u0626\u0644 \u0644\u0644\u0631\u0645\u0627\u062F\u064A",
  "green": "\u0623\u062E\u0636\u0631",
  "green cyan": "\u0633\u0645\u0627\u0648\u064A \u0645\u062E\u0636\u0631",
  "hue": "\u062F\u0631\u062C\u0629 \u0627\u0644\u0644\u0648\u0646",
  "light": "\u0641\u0627\u062A\u062D",
  "lightness": "\u0627\u0644\u0625\u0636\u0627\u0621\u0629",
  "magenta": "\u0623\u0631\u062C\u0648\u0627\u0646\u064A",
  "magenta pink": "\u0623\u0631\u062C\u0648\u0627\u0646\u064A \u0648\u0631\u062F\u064A",
  "orange": "\u0628\u0631\u062A\u0642\u0627\u0644\u064A",
  "orange yellow": "\u0623\u0635\u0641\u0631 \u0628\u0631\u062A\u0642\u0627\u0644\u064A",
  "pale": "\u0628\u0627\u0647\u062A",
  "pink": "\u0648\u0631\u062F\u064A",
  "pink red": "\u0623\u062D\u0645\u0631 \u0648\u0631\u062F\u064A",
  "purple": "\u0623\u0631\u062C\u0648\u0627\u0646\u064A",
  "purple magenta": "\u0628\u0646\u0641\u0633\u062C\u064A",
  "red": "\u0623\u062D\u0645\u0631",
  "red orange": "\u0628\u0631\u062A\u0642\u0627\u0644\u064A \u0645\u062D\u0645\u0631",
  "saturation": "\u0627\u0644\u062A\u0634\u0628\u0639",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " \u0634\u0641\u0627\u0641");
  },
  "very dark": "\u062F\u0627\u0643\u0646 \u062C\u062F\u064B\u0627",
  "very light": "\u0641\u0627\u062A\u062D \u062C\u062F\u064B\u0627",
  "vibrant": "\u0633\u0627\u0637\u0639",
  "white": "\u0623\u0628\u064A\u0636",
  "yellow": "\u0623\u0635\u0641\u0631",
  "yellow green": "\u0623\u062E\u0636\u0631 \u0645\u0635\u0641\u0631"
};
export { $2d805fd52bb48883$exports as default };